import cx from 'classnames';

import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { Background } from './Background/Background';
import { ClassicFooter } from './ClassicFooter';
import { ClassicHeader } from './ClassicHeader';

import s from './ClassicLayout.module.css';

type ClassicLayoutProps = {
  children: React.ReactNode;
};

export const ClassicLayout = ({ children }: ClassicLayoutProps) => {
  const {
    elementRef,
    showBanner,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    bnplCapabilities,
    isLoading,
  } = useBnplBanner();

  return (
    <div className={cx(s.classic, s.root)} style={bannerContainerStyle}>
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          onDismissBanner={onDismissBanner}
          isDismissed={isDismissed}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      <div className={s.container}>
        <div className={s.background} />
        <Background />
        <div className={s.container}>
          <div className={s.main}>
            <ClassicHeader />
            {children}
          </div>
        </div>
        <ClassicFooter />
      </div>
    </div>
  );
};
